module.exports = __webpack_public_path__ + "img/D0018.332c8601.svg";